module.exports = __webpack_public_path__ + "833efd873e2ed6f9.svg";